import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Box, Typography } from "@mui/material";
import { dataLayerGTM } from "../../utils/functions/dataLayerGTM";
import "./styles.scss";

const StepNumber = ({ onClick, text, gtm }) => {
  return (
    <div className="container">
      <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
        <ArrowBackOutlinedIcon
          onClick={onClick}
          sx={{ fontSize: 24, cursor: "pointer", color: "#0091DA" }}
        />
        <Typography
          color="secondary"
          sx={{
            marginLeft: "8px",
            fontSize: "14px",
            fontWeight: "700",
            lineHeight: 1.71,
          }}
        >
          {text}
        </Typography>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
        <InfoOutlinedIcon color="primary" sx={{ fontSize: 20 }} />
        <Typography
          color="primary"
          sx={{
            marginLeft: "6px",
          }}
          onClick={() => {
            if (gtm) {
              dataLayerGTM("click_tag", "Click", "Button", gtm);
            }
            window.my.navigateTo({
              url:
                "/pages/link/link?url=" +
                encodeURIComponent(
                  process.env.REACT_APP_ENV.trim() === "production"
                    ? "https://www.principal.com.my/en/immfd/mv"
                    : "https://www.test.principal.com.my/en/immfd/mv"
                ),
            });
          }}
        >
          Fund info
        </Typography>
      </Box>
    </div>
  );
};

export default StepNumber;
